import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ImgsCollection } from 'src/app/interfaces/images/imgs-collection.interface';
import { HomeTxtsKey } from 'src/app/components/pages/home/h-interfaces/txt-h-keys/home-txt-key.interface';
import { PathsDataService } from 'src/app/services/paths-data.service';
import { TextsDataService } from 'src/app/services/texts-data.service';
import { homeImgsKeys } from './h-interfaces/img-h-keys/home-img-key.interface';
import { IconsCollection } from 'src/app/interfaces/icons/icons-collection.interface';
import { homeIcnsKeys } from './h-interfaces/icns-h-keys/home-icns-key.interface';
import { SessionStorageDataService } from 'src/app/services/session-storage-data.service';
import { MessageAssistanceService } from '../../common/chat-layout-assistance/service/message-assistance.service';
import { MsgInit } from '../../common/chat-layout-assistance/interface/response-agent-API.interface';
import { map, Observable } from 'rxjs';
import { CiudUserAuthData } from 'src/app/core/auth/authData.model';
import { AuthService } from 'src/app/core/auth/auth.service';
import { ImagesService } from 'src/app/services/images.service';
import { HomeImages, ImagesData } from 'src/app/interfaces/images/image.data.interface';
import { VideoComponent } from "../../common/video/video.component";
import { env } from 'src/environments/environments';
import { ModalService } from '../../common/modal-complete-user-data/modal-service/modal.service';
import { AlertService } from 'src/app/services/alerts.service';



const DEFAULT_IMAGES: Record<string, string> =  env.DEFAULT_IMAGES;






@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  title = 'Clarity - PQRSF | AI SYSTEM';

  isAuthenticated$: Observable<boolean>;
  currentUser: CiudUserAuthData | null = null;
  userData?: CiudUserAuthData;

  imagesHome: HomeImages = {};
  imgsHome?: homeImgsKeys;
  iconsHome?: homeIcnsKeys;
  texts?: HomeTxtsKey;

  dataLoaded: boolean = false;

  is_temp_password: boolean = false;

  @ViewChild('scheduleSection', { static: false }) scheduleSection!: ElementRef;


  constructor(
    private titleService: Title,
    private pathsDataService: PathsDataService,
    private textsDataService: TextsDataService,
    private messageAssistanceService: MessageAssistanceService,
		private sessionStorageDataService: SessionStorageDataService,
    private authService: AuthService,
    private imagesService: ImagesService,
    private modalService: ModalService,
    private alertService: AlertService,
    ) {
      this.isAuthenticated$ = this.authService.ciudUser$.pipe(
        map(user => !!user)
      );

    }

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.textsDataService.getTextData().subscribe(data  => {
      if (data) {
        this.texts = data.home;
      }
    });
    // this.resquestPathImgs();
    // this.resquestPathIcns();
    this.getMsgInitLocal();
    this.getImagesAssets();

    const userSession = sessionStorage.getItem('user');
    this.is_temp_password = userSession ? JSON.parse(userSession).is_temp_password ?? false : false;
  }



  checkDataLoaded() {
    if (this.imgsHome /* && this.iconsHome && this.imagesHome */) {
        this.dataLoaded = true;
    }
  }


  scrollToScheduleSection() {
    const scheduleSection = this.scheduleSection.nativeElement;
    if (scheduleSection) {
        const yOffset = scheduleSection.getBoundingClientRect().top + window.scrollY - 100 // Ajuste de scroll-mt
        window.scrollTo({
            top: yOffset,
            behavior: 'smooth'
        });
    }
  }



  defaultPathImg() {
    console.warn("Usando rutas de imágenes predeterminadas debido a un error en el servicio.");
    this.imagesHome = { ...DEFAULT_IMAGES };
  }


  // Mapear las secciones a un objeto más accesible
  private mapImagesToSections(data: ImagesData[]): HomeImages {
    const images: HomeImages = {};
    data.forEach((item) => {
      if (item.seccion) {
        const key = this.normalizeSectionKey(item.seccion);
        images[key] = item.ruta;
      }
    });
    return images;
  }

  private normalizeSectionKey(section: string): string {
    return section
      .toLowerCase()
      .replace(/\s+/g, '') // Elimina espacios
      .replace(/[^a-z0-9]/g, ''); // Elimina caracteres no alfanuméricos
  }


  private checkSessionStorageForTempPassword(): void {
    const userSession = sessionStorage.getItem('user');
    if (userSession) {
      console.warn('Datos de usuario en sessionStorage:', userSession);
      try {
        const userData = JSON.parse(userSession);
        console.warn('Datos de usuario parseados:', userData);

        // Si ya tenemos un valor desde ciudUser$, respetar ese valor
        if (this.is_temp_password === false) {
          // Comprobación estricta para asegurarse de que is_temp_password es explícitamente true
          this.is_temp_password = userData && userData.is_temp_password === true;
        }
      } catch (e) {
        console.error('Error al parsear datos de usuario de sessionStorage', e);
        this.is_temp_password = false;
      }
    } else {
      console.warn('No hay datos de usuario en sessionStorage');
      // Si no hay datos en sessionStorage, asegurarse de que is_temp_password sea false
      this.is_temp_password = false;
    }
  }


  private updateSessionStorage(user: CiudUserAuthData): void {
    // Este método puede ser útil si necesitas sincronizar sessionStorage
    const storedUserStr = sessionStorage.getItem('user');

    if (storedUserStr) {
      try {
        const storedUser = JSON.parse(storedUserStr);

        // Comprobar si hay discrepancia entre la sesión almacenada y el usuario actual
        if (storedUser.is_temp_password !== user.is_temp_password) {
          storedUser.is_temp_password = user.is_temp_password;
          sessionStorage.setItem('user', JSON.stringify(storedUser));
        }
      } catch (e) {
        console.error('Error al actualizar sessionStorage:', e);
      }
    }
  }


  // Método para abrir el diálogo desde HomeComponent
  handleWhatsappLinkClick(event: Event): void {
    const user = sessionStorage.getItem('user');

    if (user) {
      const parsedUser = JSON.parse(user);

      if (parsedUser.logGoogle === true) {
        if (parsedUser.telefono === '0') {
          event.preventDefault(); // Prevenir que se abra el enlace
          this.modalService.openDialog();  // Abrir el diálogo
        }
      } else {
        console.warn('Usuario logueado con otro método');
      }
    } else {
      event.preventDefault();
      this.alertService.showAlert('Por favor inicie sesion para acceder al chat de WhatsApp', 'info');
    }
  }


  getImagesAssets(): void {
    this.imagesService.getImages().subscribe({
      next: (response) => {
        if (response.success && Array.isArray(response.data)) {
          // Mapear las secciones a un objeto más accesible
          this.imagesHome = this.mapImagesToSections(response.data);
          this.checkDataLoaded();
        } else {
          //this.defaultPathImg();
            this.resquestPathImgs();
          console.error('Error al obtener imágenes:', response.message);
        }
      },
      error: (error) => {
        this.defaultPathImg();
        console.error('Error en el servicio:', error);
      }
    });
  }



  resquestPathImgs() {
    this.pathsDataService.getPathImgs()
    .subscribe({
        next: (data: ImgsCollection) => {
            this.imgsHome = data.home;
            this.checkDataLoaded();
        },
        error: (error) => {
            console.error(error);
        }
    });
  }


  resquestPathIcns() {
    this.pathsDataService.getPathIcons()
    .subscribe({
      next: (data: IconsCollection) => {
        this.iconsHome = data.home;
        this.checkDataLoaded();
      },
      error: (error) => {
        console.error(error);
      }
    });
  }


  getMsgInitLocal() {
    this.messageAssistanceService.initialMessage().subscribe({
        next: (response) => {
            if (response.success) {
                const msgInit: MsgInit = response.data ?? {} as MsgInit;
                //this.sessionStorageDataService.saveData('msgInit', msgInit);
                sessionStorage.setItem('msgInit', JSON.stringify(msgInit));
            }
        },
        error: (error) => {
            console.error('Error en el servicio: ', error);
        }
    });
  }






}
